<template>
  <DxDataGrid class="isScrolledByGeneralFilter" :data-source="data" :show-borders="true"
    @exporting="$emit('exporting', $event)" :scrolling="{ useNative: true }"
    :column-auto-width="true">
    <DxExport :enabled="true" />
    <DxColumn data-field="ID_Item" caption="ID del producto" />
    <DxColumn data-field="ItemName" caption="Nombre del producto" />
    <DxColumn data-field="WarehouseName" caption="Almacen" />
    <DxColumn data-field="ItemMeasureUnit" caption="Unidad de medida del producto" />
    <DxColumn data-field="TotalStock" caption="Cantidad disponible" />
    <DxColumn data-field="CostoPromedio" caption="Costo unitario" />
    <DxColumn data-field="TotalCost" caption="Costo total" />
    <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
    <DxPaging :page-size="10" />
  </DxDataGrid>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxExport,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";

export default {
  name: "InventoryCostReportTable",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxExport,
    DxPager,
    DxPaging,
  }
};
</script>
